"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/list/style/css");

var _list = _interopRequireDefault(require("antd/es/list"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireWildcard(require("react"));

var _button = _interopRequireDefault(require("antd/lib/button"));

var _collapse = _interopRequireDefault(require("antd/lib/collapse"));

var _icons = require("@ant-design/icons");

var _ScreenerOptionItem = _interopRequireDefault(require("./ScreenerOptionItem"));

require("./screenerOptionGroup.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Panel
} = _collapse.default;
const {
  Item
} = _form.default;

class ScreenerOptionGroup extends _react.Component {
  constructor() {
    super(...arguments);
    this.styles = {
      addButton: {
        width: '200px',
        color: '#439AFF',
        borderColor: '#439AFF',
        backgroundColor: '#D0E6FF'
      },
      removeButton: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#f17878',
        borderColor: '#f17878',
        backgroundColor: '#FBDDDD',
        marginLeft: '5px',
        width: '32px',
        height: '32px'
      },
      panelExtra: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start'
      }
    };

    this.validateOptionGroup = (rule, value) => {
      const {
        options,
        header
      } = this.props;

      try {
        if (options.length === 0) {
          throw new Error(`(${header}) An option group must have at least one option.`);
        }

        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      }
    };
  }

  render() {
    const {
      disabledProp: disabled,
      optionGroupId,
      options,
      addOption,
      updateOption,
      removeOption,
      removeGroup
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(Item, {
      key: `option-group-items-${optionGroupId}`,
      name: `option-group-items-${optionGroupId}`,
      rules: [{
        required: true,
        validator: this.validateOptionGroup
      }],
      noStyle: true
    }, /*#__PURE__*/_react.default.createElement(Panel, Object.assign({
      key: `option-group-panel-${optionGroupId}`,
      className: "option-group-panel",
      extra: /*#__PURE__*/_react.default.createElement("div", {
        style: this.styles.panelExtra,
        onClick: e => e.stopPropagation()
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        key: `add-option-${optionGroupId}`,
        style: this.styles.addButton,
        onClick: () => addOption(optionGroupId),
        disabled: disabled,
        type: "dashed",
        title: "Add new option to group"
      }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null), ' ', "Add option"), /*#__PURE__*/_react.default.createElement(_button.default, {
        key: `remove-group-${optionGroupId}`,
        style: this.styles.removeButton,
        onClick: removeGroup,
        disabled: disabled,
        title: "Remove option group"
      }, /*#__PURE__*/_react.default.createElement(_icons.CloseOutlined, null)))
    }, this.props), /*#__PURE__*/_react.default.createElement(_list.default, {
      itemLayout: "horizontal",
      dataSource: options,
      renderItem: o => {
        return /*#__PURE__*/_react.default.createElement(_ScreenerOptionItem.default, {
          key: `option-item-${o.uuid}`,
          disabled: disabled,
          option: o,
          updateOption: updateOption,
          removeOption: removeOption
        });
      }
    })));
  }

}

var _default = ScreenerOptionGroup;
exports.default = _default;